<template>
  <div>
    <el-row type="flex" class="title-bar" :style="'justify-content:' + (operationFlag ? 'flex-end;' : 'space-between;')">
      <w-perf-analysis-time-info v-if="!operationFlag" :ref="timeInfoRef" :checkDatetime="checkDatetime" @change="onTimeTypeChange" @reload="onCurrentDataReLoad" />
      <w-header-search-button @click="onShowSearchToolButtonClick"></w-header-search-button>
    </el-row>
    <el-row>
      <el-table-wrapper v-show="(this.timeType === 'current' || operationFlag)" border v-loading="loading" :data="tableData" :columns="tableColumns" :show-custom-header="true"
      :show-search-tool="showSearchTool" ref="table" style="width:100%;" :pagination="true" :column-default="columnDefault">
        <template #interface-name="scope">
          <span v-if="scope.row.objName" class="link c-pointer" @click="clickInterfaceName(scope.row)">{{ scope.row.objName }}</span>
          <span v-else>-</span>
        </template>
      </el-table-wrapper>
      <el-table-wrapper v-show="(this.timeType === 'hist' && !operationFlag)" border v-loading="loading" :data="tableData" :columns="tableColumns" :show-custom-header="true"
      :show-search-tool="showSearchTool" style="width:100%;" :pagination="true" :column-default="columnDefault">
        <template #interface-name="scope">
          <span v-if="scope.row.objName" class="link c-pointer" @click="clickInterfaceName(scope.row)">{{ scope.row.objName }}</span>
          <span v-else>-</span>
        </template>
      </el-table-wrapper>
    </el-row>
  </div>
</template>
<script>

import { isNil, isEmpty, concat } from 'lodash';
import { routePathByObjId } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import { objCompanyDefine } from '@/constants/company';
import msgUtil from '@/utils/message';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import { isTrue } from '@/utils/boolean';
import { columnDefault } from '@/constants/table';
import { analysisTimeType, performanceNodeTabs } from '@/constants/performance';
import netdeviceTableInfoAPI from '@/api/performance/netdevice/netdevice-table-info';
import analysisTableMixin from '@/mixins/performance/analysis-table-ex';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';

export default {
  name: 'WPoePowerTable',
  mixins: [analysisTableMixin],
  components: {
    WPerfAnalysisTimeInfo,
  },
  data() {
    return {
      columnDefault,
      loading: false,
      checkDatetime: null,
      tableData: null,
      total: null,
      showSearchTool: false,
      columns: [
        {
          prop: 'netinterfaceIfindex',
          label: '인덱스',
          searchable: true,
          sortable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'objName',
          label: '인터페이스명',
          searchable: true,
          scopedSlot: 'interface-name',
          sortable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'netinterfaceAlias',
          label: '별칭',
          searchable: true,
          sortable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'POE_PORT/POE_PORT',
          label: '파워 상태',
          sortable: true,
          formatter: this.getPoEStatusValue,
        },
        {
          prop: 'POE_PORT/PORT_POWER_CONSUMED',
          label: 'PD 소비 전력',
          sortable: true,
          formatter: this.getPoePowerValue,
        },
        {
          prop: 'POE_PORT/PORT_POWER_ALLOCATED',
          label: 'PSE 예약 전력',
          sortable: true,
          formatter: this.getPoePowerValue,
        },
      ],
    };
  },
  computed: {
    tableColumns() {
      return this.selectedNode.obj.objCompanyId === objCompanyDefine.CISCO ? this.columns : concat(this.columns, [{
        prop: 'POE_PORT/PORT_VOLTAGE',
        label: 'PSE 전압',
        sortable: true,
        formatter: this.getPoePowerValue,
      }]);
    },
  },
  methods: {
    loadData() {
      this.$nextTick(() => {
        const params = {
          objId: this.selectedNode.obj.objId,
          managetypeId: 'NMS',
        };
        // 이력
        if (this.timeType === analysisTimeType.HIST.value && !this.operationFlag) {
          this.loading = true;
          params.baselineDatetime = this.plotLineDatetime;
          netdeviceTableInfoAPI.getPoeInterfacePowerList(params).then((response) => {
            if (response.data.success === true) {
              const snapshotData = response.data.data;
              this.tableData = snapshotData.snapshotDoc;
              this.checkDatetime = snapshotData.timestamp;
            } else {
              this.failToLoad();
            }
          }).catch(() => {
            this.failToLoad();
          }).finally(() => {
            this.loading = false;
          });
        } else {
          // 현재 or 운영탭
          this.loading = true;
          const searchParams = this.$refs.table.getParameter();
          const targetParams = {
            ...params,
            ...searchParams,
          };
          netdeviceTableInfoAPI.getCurrentPoeInterfacePowerList(targetParams).then((response) => {
            if (response.data.success === true) {
              this.tableData = response.data.data;
              this.total = response.data.total;
            } else {
              this.failToLoad();
            }
          }).catch(() => {
            this.failToLoad();
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },
    failToLoad() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '전력 정보', false));
    },
    /**
     * 검색 기능 show on/off
     * @author Hunui
     * @return {[type]} [description]
     */
    onShowSearchToolButtonClick() {
      this.showSearchTool = !this.showSearchTool;
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * PoE 상태 formatter
     * @author Hunui
     */
    getPoEStatusValue(row, column, value) {
      if (isNil(value) || value === '') {
        return EMPTY_TEXT;
      }
      return isTrue(value) ? 'UP' : 'DOWN';
    },
    /**
     * PoE 전력값 formatter
     * @author Hunui
     */
    getPoePowerValue(row, column, value) {
      // TODO: 현재 현재값은 DB에서 조회하여 rsc_unit을 가져오나 스냅샷은 구현이 되어있지 않아 하드코딩
      //       추후 스냅샷도 수정하여 동적으로 바뀌도록 수정필요
      return isEmpty(value) ? convertValuByUnit(value, 'w', true, false, false, true) : getValueAfterCheckEmpty(value);
    },
    /**
     * 인터페이스 명 클릭 시 성능운영 새 탭으로 제공
     * @author Hunui
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickInterfaceName(row) {
      if (!isNil(row.objId)) {
        routePathByObjId(this, row.objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, isEmpty(this.selectedNode) ? undefined : this.selectedNode.childManagegroupIds, null, false);
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/netdevice/components/table/PoePowerTable.vue